<template>
  <div  class="modal-open">
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ userDetails.username }}, {{ getTranslations.home_modals_unsubscribe_do_you_want }}</h1>
          <img class="modal_icon_main" src="/static/images/resub-prize.png" alt="">
          <p>{{ getTranslations.home_modals_unsubscribe_if_you_unsubscribe }}</p>
          <p>{{ getTranslations.home_modals_unsubscribe_do_you_want_continue }}</p>

        </div>
        <div class="modal__footer">
          <span class="terms ">{{ getTranslations.home_modals_unsubscribe_in_order_to_unsubscribe_send }}
            {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_unsub_unsubscribesms_modal_stop') }} {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_modals_unsubscribe_to') }}
            {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_unsub_unsubscribesms_modal_xxxx') }}</span>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'unsubscribe-sms',
  components: {
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/UnsubscribeSms.vue